<template>
  <div class="form">
    <b-row>
      <b-col md="6">
        <b-form-group horizontal :label-cols="3" :label="$lang('姓名：')">
          <b-form-input
            type="text"
            v-model="value.name"
            name="name"
            :class="errors.has('name') && 'is-invalid'"
            v-validate="{ ...rules.name, required: requiredType }"
            :placeholder="$lang('請輸入名字')"
            :disabled="disabled"
          />
          <b-form-invalid-feedback :state="errors.has('name')">
            {{ errors.first("name") }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group horizontal :label-cols="3" :label="$lang('性別：')">
          <b-select
            v-model="value.gender"
            name="sex"
            :class="errors.has('sex') && 'is-invalid'"
            v-validate="{ ...rules.sex, required: requiredType }"
            :placeholder="$lang('請輸入性別')"
            :disabled="disabled"
          >
            <option value="M">{{ $lang("FIELD_MALE") }}</option>
            <option value="F">{{ $lang("FIELD_FEMALE") }}</option>
          </b-select>
          <b-form-invalid-feedback :state="errors.has('sex')">
            {{ errors.first("sex") }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group
          horizontal
          :label-cols="3"
          :label="$lang('FIELD_ID_NUMBER')"
        >
          <b-form-input
            type="text"
            v-model="value.idNumber"
            name="idNumber"
            :class="errors.has('idNumber') && 'is-invalid'"
            v-validate="{
              ...rules.cycling_idNumber,
              cycling_idNumber: true,
              required: requiredType,
            }"
            :placeholder="$lang('請輸入證件號碼後4位')"
            :disabled="disabled"
          />
          <b-form-invalid-feedback :state="errors.has('idNumber')">
            {{ errors.first("idNumber") }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
        <b-col md="6" v-if="value.hasOwnProperty('phone')">
        <b-form-group horizontal :label-cols="3" :label="$lang('電話號碼：')">
          <b-form-input
            type="text"
            v-model="value.phone"
            name="phone"
            :class="errors.has('phone') && 'is-invalid'"
            v-validate="{
              ...rules.mobile,
              mobile: value.phone,
              required:false,
            }"
            :placeholder="$lang('請輸入電話號碼')"
            :disabled="disabled"
          />
          <b-form-invalid-feedback :state="errors.has('phone')">
            {{ errors.first("phone") }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group horizontal :label-cols="3" :label="$lang('上車地點:')">
          <b-input-group>
            <b-form-select
              v-validate="{ ...rules.sex, required: requiredType }"
              :placeholder="$lang('請選擇地點')"
              :disabled="disabled"
              v-model="value.location"
              name="location"
              :class="errors.has('location') && 'is-invalid'"
              :options='locationOptions'
            >
              <!-- <option :value="1">{{ $lang("澳門綜藝館") }}</option>
              <option :value="2">
                {{ $lang("氹仔中央公園(近哥英布拉街位置)") }}
              </option>
              <option :value="3">
                {{
                  $lang("自行前往活動地點(請於09:20前到達黑沙水庫郊野公園廣場)")
                }}
              </option> -->
            </b-form-select>
            <b-form-invalid-feedback :state="errors.has('location')">{{
              errors.first("location")
            }}</b-form-invalid-feedback>
          </b-input-group>
        </b-form-group>
      </b-col>
      <!-- <b-col v-show="false" md="6">
            <b-form-group :label-cols="3" :label="$lang('參與日期：')">
            <b-form-checkbox-group
                v-model="value.participateDate"
                :class="errors.has('participateDate') && 'is-invalid'"
                v-validate="{required: false}"
                :options="participateDate"
                name="participateDate"
                :disabled="disabled || participateDate.isCanSignUp"
            ></b-form-checkbox-group>
            <b-form-invalid-feedback :state="errors.has('participateDate')">
                {{ errors.first("participateDate") }}
                </b-form-invalid-feedback>
            </b-form-group>
        </b-col> -->
      <b-col md="12" v-if="!disabled">
        <slot name="remove"></slot>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      default() {
        return {
          name: "",
          gender: "M",
          idNumber: "",
          participateDate: [],
        };
      },
    },
    locationOptions: {
      type: Array,
      default: [],
    },

    disabled: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: Object,
    },
    requiredType: {
      type: Boolean,
    },
    participateDate: {
      type: Array,
    },
  },
  data() {
    return {
      options: [
        { text: "是", value: true },
        { text: "否", value: false },
      ],
    };
  },
  methods: {
    onSubmit() {
      return new Promise((resolve, reject) => {
        this.$validator.validate().then((result) => {
          resolve(result);
        });
      });
    },
    validateErrors(field, msg) {
      this.errors.add({
        field,
        msg,
      });
    },
  },
};
</script>
